module.exports = __webpack_public_path__ + "static/media/know12.e05395b5.jpg";